export default "__VITE_ASSET__BgVnn0w6__"